import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { FieldType, FieldAdded } from 'src/app/core/models/application';
import { ApplicationService } from 'src/app/core/services/application.service';
import { ManageTooltipService } from 'src/app/core/services/manage-tooltip.service';



@Component({
  selector: 'app-add-field',
  templateUrl: './add-field.component.html',
  styleUrls: ['./add-field.component.scss']
})
export class AddFieldComponent implements OnInit {

  toAddFields: FieldType[]= [
    { name : 'Textbox', value: 'textbox' },
    { name : 'Checkbox', value: 'checkbox' },
    { name : 'Dropdown', value: 'dropdown' },
    { name : 'Input File Upload', value: 'inputFile' },
  ];
  addFieldForm: UntypedFormGroup;
  tooltipHtml: string = '';
  alreadyAddedNames: string[] = []
  nameCheckSub: Subscription;
  currentIndex: number = this.data.fieldAdded + 1;

  constructor(
    private dialog: MatDialogRef<AddFieldComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { editObj: FieldAdded, fieldAdded: number },
    private tooltipJson: ManageTooltipService,
    private applicationService: ApplicationService
  ) { }

  ngOnInit(): void {
    this.addFieldForm = new UntypedFormGroup({
      fieldType: new UntypedFormControl(this.toAddFields[0].value),
      fieldName: new UntypedFormControl(null, [Validators.required]),
      isFieldRequired: new UntypedFormControl(true),
      fieldValue: new UntypedFormControl(null),
    })
    this.nameCheckSub = this.applicationService.AddedUniqueNames.subscribe((names: string[]) => {
      if(names){
        this.alreadyAddedNames = names
      }
    })
    if(this.data.editObj){
      this.onEditMode(this.data.editObj)
    }
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.nameCheckSub.unsubscribe();
  }

  onEditMode(obj: FieldAdded){
    this.currentIndex = obj.id;
    this.applicationService.removeUniqueName(obj.uniqueName);
    this.addFieldForm.controls['fieldType'].setValue(obj.fieldType);
    this.addFieldForm.controls['fieldName'].setValue(obj.fieldName);
    this.addFieldForm.controls['isFieldRequired'].setValue(obj.isFieldRequired);
    this.addFieldForm.controls['fieldValue'].setValue(obj.fieldValue);
  }

  onSubmit(){
    if(this.addFieldForm.status == 'INVALID') {
      this.addFieldForm.markAllAsTouched();
      return;
    };
    this.addFieldForm.controls['fieldName'].setValue(this.addFieldForm.controls['fieldName'].value.trim())
    if(this.alreadyAddedNames.includes(this.addFieldForm.controls['fieldName'].value)){
      return;
    }
    this.createUniqueId(this.addFieldForm.value.fieldName)
    let newObj: FieldAdded = {
      id: this.currentIndex,
      uniqueName: this.createUniqueId(this.addFieldForm.value.fieldName),
      fieldType: this.addFieldForm.value.fieldType,
      fieldName: this.addFieldForm.value.fieldName,
      fieldValue: this.addFieldForm.value.fieldValue,
      isFieldRequired: this.addFieldForm.value.isFieldRequired,
    }
    if(newObj.isFieldRequired){
      newObj.errorMsg = `${newObj.fieldName} required`
    }
    this.dialog.close(newObj)
  }

  onClose(){
    if(this.data.editObj)this.applicationService.updateAddedUniqueNames(this.data.editObj.uniqueName)
    this.dialog.close(false);
  }

  getTooltip(tooltipOf: string){
    this.tooltipHtml = null;
    if(tooltipOf == 'fieldValue'){
      if(this.addFieldForm.controls['fieldType'].value == 'dropdown'){
        tooltipOf = 'fieldValueDropdown'
      } else if(this.addFieldForm.controls['fieldType'].value == 'textbox') {
        tooltipOf = 'fieldValueTextbox'
      } else if(this.addFieldForm.controls['fieldType'].value == 'checkbox') {
        tooltipOf = 'fieldValueCheckbox'
      }
    }
    this.tooltipHtml = this.tooltipJson.getTooltipOf("application", tooltipOf);
  }

  createUniqueId(fieldName: string) {
    fieldName = fieldName.replace(/[^a-zA-Z0-9 ]/g, "")
    return fieldName.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function(match, index) {
      if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    });
  }

  fieldTypeUpdated(){
    if(['dropdown', 'checkbox'].includes(this.addFieldForm.value.fieldType)){
      this.addFieldForm.controls['fieldValue'].setValidators([Validators.required])
    } else {
      this.addFieldForm.controls['fieldValue'].setValidators(null)
    }
    this.addFieldForm.controls['fieldValue'].setValue(null)
    if(this.addFieldForm.value.fieldType == 'checkbox'){
      this.addFieldForm.controls['fieldValue'].setValue(true)
      this.addFieldForm.controls['isFieldRequired'].setValue(false)
    }
    this.addFieldForm.controls['fieldValue'].updateValueAndValidity()
  }
}
